import { MainFooter } from "Components/MainFooter";
import { PageWrapper } from "Components/MainPageWrapper";
import deepmerge from "deepmerge";
import React from "react";
import { serverConstants } from "Shared/Constants";

export function TransitionLogo(props: { style?: React.CSSProperties }) {
  return (
    <nav
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div>
        <a href={serverConstants.StaticSiteUrl}>
          <img
            alt={`${serverConstants.CompanyName} Logo`}
            src="/img/Logos/levelesq-logo-color-01.svg"
            style={{
              backgroundColor: "white",
              height: 100,
              ...props.style,
            }}
          />
        </a>
      </div>
    </nav>
  );
}

function Header() {
  return (
    <header id="header" style={{ padding: "1em", backgroundColor: "white" }}>
      <TransitionLogo />
    </header>
  );
}

export function LcpAppPageWrapper(props: {
  isWide?: boolean;
  documentTitle: string;
  onClose?: () => void;
  children: React.ReactNode;
  theme?: {
    mainDivStyle?: React.CSSProperties;
  };
  programPrefix?: string;
}) {
  const wideTheme = { mainDivStyle: { maxWidth: "769px" } };
  return (
    <PageWrapper
      {...props}
      theme={deepmerge(
        props.isWide === true ? wideTheme : {},
        props.theme ?? {},
      )}
      header={<Header />}
      footer={<MainFooter />}
      documentTitle={`${props.documentTitle} - ${props.programPrefix ?? ""}${
        serverConstants.InsuranceName
      } - ${serverConstants.CompanyName}`}
    />
  );
}
